import React, { useState, useEffect } from "react";
import { Navigation } from "./Navigation";
import { HeroSection } from "./HeroSection";
import { ValidationFlowSection } from "./ValidationFlowSection";
import { HorizontalAccordionSection } from "./HorizontalAccordionSection";
import { TrustSection } from "./TrustSection";
import { CTASection } from "./CTASection";
import { Footer } from "./Footer";
import { LineSidebar } from "./LineSidebar";

// Main Landing Page
export const CynapsLanding = () => {
  const [activeSection, setActiveSection] = useState<number>(0);
  
  const SIDEBAR_ITEMS = ['Capabilities', 'Modalities', 'Infrastructure', 'Start'];
  const SECTION_IDS = ['section-simulation', 'section-ecosystem', 'section-validation', 'section-start'];

  useEffect(() => {
    const handleScroll = () => {
      // Find which section is currently in view (upper third of viewport)
      const scrollPosition = window.scrollY + window.innerHeight * 0.38;
      
      let currentSection = 0;
      for (let i = 0; i < SECTION_IDS.length; i++) {
        const element = document.getElementById(SECTION_IDS[i]);
        if (element) {
          const rect = element.getBoundingClientRect();
          const elementTop = rect.top + window.scrollY;
          if (scrollPosition >= elementTop) {
            currentSection = i;
          }
        }
      }
      
      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    // Small delay to ensure layout is ready
    setTimeout(handleScroll, 100); 
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSidebarClick = (index: number) => {
    setActiveSection(index);
    const element = document.getElementById(SECTION_IDS[index]);
    if (element) {
      const navOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="bg-black min-h-screen">
      {/* Main page content curtain */}
      <div className="relative z-10 bg-black min-h-screen shadow-[0_30px_60px_rgba(0,0,0,0.9)]">
        <Navigation isHeroPage={true} />
        <HeroSection />
        
        <div className="flex w-full relative">
          {/* Sticky Sidebar Container */}
          <div className="hidden lg:flex sticky top-0 h-screen w-64 flex-shrink-0 items-center pl-8 z-40 pointer-events-auto">
            <LineSidebar 
              items={SIDEBAR_ITEMS} 
              activeIndex={activeSection}
              onItemClick={handleSidebarClick}
              accentColor="#ffffff"
              textColor="#737373"
              markerColor="#404040"
              fontSize={0.8}
              itemGap={36}
            />
          </div>
          
          {/* Main Content Area */}
          <div className="flex-1 w-full min-w-0">
            <div id="section-simulation" className="scroll-mt-28">
              <ValidationFlowSection />
            </div>
            <div id="section-ecosystem" className="scroll-mt-28">
              <HorizontalAccordionSection />
            </div>
            <div id="section-validation" className="scroll-mt-28">
              <TrustSection />
            </div>
            <div id="section-start" className="scroll-mt-28">
              <CTASection />
            </div>
          </div>
        </div>
      </div>

      {/* Motion UI Sticky Reveal Footer */}
      <Footer />
    </div>
  );
};

export default CynapsLanding;
